export const UniversityUSA = [
  "Akron University",
  "Alabama A&M University",
  "Alabama State University",
  "Alaska Pacific University",
  "Alcorn State University",
  "American Public University System",
  "American University",
  "Amherst College",
  "Anderson University",
  "Appalachian State University",
  "Arizona State University",
  "Arkansas State University",
  "Arkansas Tech University",
  "Art Institute of Las Vegas",
  "Ashford University",
  "Auburn University",
  "Augustana College",
  "Austin College",
  "Ball State University",
  "Bates College",
  "Baylor University",
  "Bellevue College",
  "Belmont University",
  "Bennington College",
  "Bismarck State College",
  "Black Hills State University",
  "Boise State University",
  "Boston College",
  "Boston University",
  "Bowdoin College",
  "Bowling Green State University-Main Campus",
  "Brigham Young University-Hawaii",
  "Brigham Young University-Idaho",
  "Brigham Young University-Provo",
  "Brown University",
  "Butler University",
  "California Polytechnic Pomona",
  "California State, Northridge",
  "California State University, Bakersfield",
  "California State University, Chico",
  "California State University, Dominguez Hills",
  "California State University, Fresno",
  "California State University, Fullerton",
  "California State University, Long Beach",
  "California State University, Los Angeles",
  "California State University, Sacramento",
  "California State University, San Bernardino",
  "California State University, Stanislaus",
  "California State University-Long Beach",
  "Capella University",
  "Carnegie Mellon University",
  "Carroll College",
  "Casper College",
  "Castleton State College",
  "Catholic University of America",
  "Central Michigan University",
  "Central New Mexico Community College",
  "Central Washington University",
  "Chaminade University of Honolulu",
  "Champlain College",
  "Chapman University",
  "Charles Darwin University",
  "Charles Sturt University",
  "Charter College-Anchorage",
  "Clark Atlanta University",
  "Clemson University",
  "Coastal Carolina University",
  "Colby College",
  "College of Charleston",
  "College of New Jersey",
  "College of Southern Idaho",
  "College of Southern Nevada",
  "Colorado Mesa University",
  "Colorado State University-Fort Collins",
  "Columbia University in the City of New York",
  "Concord University",
  "Cornell University",
  "Creighton University",
  "CUNY Hunter College",
  "Dakota State University",
  "Dartmouth College",
  "Delaware State University",
  "Delaware Technical Community College-Owens",
  "Delaware Technical Community College-Stanton/Wilmington",
  "Delaware Technical Community College-Terry",
  "DePaul University",
  "Des Moines Area Community College",
  "Drake University",
  "Drexel University",
  "Duke University",
  "East Carolina University",
  "Eastern Kentucky University",
  "Eastern Michigan University",
  "Eastern New Mexico University-Main Campus",
  "Eastern Washington University",
  "Elon University",
  "Emory University",
  "Emporia State University",
  "Fairmont State University",
  "Florida Atlantic University",
  "Florida Gulf Coast University",
  "Florida International University",
  "Florida State University",
  "Fordham University",
  "Fort Hays State University",
  "Franklin Pierce University",
  "Gallaudet University",
  "George Mason University",
  "Georgetown University",
  "George Washington University",
  "Georgia Institute of Technology-Main Campus",
  "Georgia Southern University",
  "Georgia State University",
  "Gonzaga University",
  "Grambling State University",
  "Grand Canyon University",
  "Grand Valley State University",
  "Harding University",
  "Harvard University",
  "Hawaii Community College",
  "Hawaii Pacific University",
  "Hinds Community College",
  "Hollins University",
  "Howard University",
  "Idaho State University",
  "Ilisagvik College",
  "Illinois State University",
  "Indiana State University",
  "Indiana University-Bloomington",
  "Indiana University-Purdue University-Indianapolis",
  "Iowa State University",
  "Jackson State University",
  "James Madison University",
  "Jamestown College",
  "Johns Hopkins University",
  "Johnson &amp; Wales University-Providence",
  "Johnson County Community College",
  "Kansas State University",
  "Kaplan University-Davenport Campus",
  "Keene State College",
  "Kent State University at Kent",
  "Keuka College",
  "Laramie County Community College",
  "Le Cordon Bleu College of Culinary Arts-Las Vegas",
  "Lewis &amp; Clark College",
  "Liberty University",
  "Louisiana State University",
  "Louisiana State University and Agricultural &amp; Mechanical College",
  "Loyola University-Chicago",
  "Marquette University",
  "Marshall University",
  "Massachusetts Institute of Technology",
  "Mesa Community College",
  "Metropolitan Community College Area",
  "Metropolitan State College of Denver",
  "Miami University-Oxford",
  "Michigan State University",
  "Middlebury College",
  "Middle Tennessee State University",
  "Minnesota State University-Mankato",
  "Minot State University",
  "Mississippi College",
  "Mississippi State University",
  "Missouri State University-Springfield",
  "Montana State University",
  "Montana State University-Billings",
  "Montana Tech of the University of Montana",
  "Montclair State University",
  "Morehead State University",
  "Morgan State University",
  "Murray State University",
  "Nevada State College",
  "New Mexico Highlands University",
  "New Mexico State University-Main Campus",
  "New York University",
  "North Carolina A&amp;T State University",
  "North Carolina State University at Raleigh",
  "North Dakota State College of Science",
  "North Dakota State University-Main Campus",
  "Northeastern State University",
  "Northeastern University",
  "Northern Arizona University",
  "Northern Illinois University",
  "Northern Kentucky University",
  "Northern State University",
  "North Idaho College",
  "Northwest College",
  "Northwestern University",
  "Northwest Nazarene University",
  "Norwich University",
  "Notre Dame",
  "Oberlin College",
  "Ohio State University",
  "Ohio University",
  "Oklahoma City University",
  "Oklahoma State University",
  "Old Dominion University",
  "Oral Roberts University",
  "Oregon State University",
  "Pacific Lutheran University",
  "Pennsylvania State University-Main Campus",
  "Pittsburg State University",
  "Plymouth State University",
  "Portland Community College",
  "Portland State University",
  "Princeton University",
  "Providence College",
  "Purdue University-Main Campus",
  "Quinnipiac University",
  "Regis University",
  "Rhode Island College",
  "Rhode Island School of Design",
  "Rocky Mountain College",
  "Roger Williams University",
  "Rowan University",
  "Rutgers University-Newark",
  "Rutgers University-New Brunswick",
  "Sacramento State University",
  "Sacred Heart University",
  "Saint Anselm College",
  "Saint Cloud State University",
  "Saint Louis University-Main Campus",
  "Saint Michael's College",
  "Salisbury University",
  "Salt Lake Community College",
  "San Diego State University",
  "San Francisco State University",
  "San Jose State University",
  "Santa Fe Community College",
  "Seattle Pacific University",
  "Seattle University",
  "Seton Hall University",
  "Shepherd University",
  "Sheridan College",
  "Sonoma State University",
  "South Carolina State University",
  "South Dakota School of Mines and Technology",
  "South Dakota State University",
  "Southeastern Louisiana University",
  "Southeast Missouri State University",
  "Southern Connecticut State University",
  "Southern illinois University of Carbondale",
  "Southern Maine Community College",
  "Southern New Hampshire University",
  "Southern Oregon University",
  "Southern University and A&amp;M College",
  "Southern Utah University",
  "South Florida University",
  "Southwestern College",
  "Spelman College",
  "St. Cloud State University",
  "Stanford University",
  "Stony Brook University",
  "Syracuse University",
  "Temple University",
  "Tennessee State University",
  "Texas A&amp;M University-College Station",
  "Texas Tech University",
  "Towson University",
  "Trinity Lutheran College",
  "Troy University",
  "Truckee Meadows Community College",
  "The Evergreen State College",
  "Tufts University",
  "Tulane University of Louisiana",
  "Union College",
  "University at Buffalo",
  "University California, Riverside",
  "University of Alabama",
  "University of Alabama at Birmingham",
  "University of Alaska Anchorage",
  "University of Alaska Fairbanks",
  "University of Alaska Southeast",
  "University of Arizona",
  "University of Arkansas",
  "University of Arkansas at Little Rock",
  "University of Arkansas-Fort Smith",
  "University of Auburn",
  "University of California, Davis",
  "University of California, Santa Barbara",
  "University of California-Berkeley",
  "University of California Irvine",
  "University of California-Los Angeles",
  "University of California Merced",
  "University of California Riverside",
  "University of California-San Diego",
  "University of California Santa Cruz",
  "University of Central Arkansas",
  "University of Central Florida",
  "University of Central Missouri",
  "University of Central Oklahoma",
  "University of Chicago",
  "University of Cincinnati",
  "University of Colorado Boulder",
  "University of Colorado-Colorado Springs",
  "University of Colorado Denver",
  "University of Connecticut",
  "University of Delaware",
  "University of Denver",
  "University of Florida",
  "University of Georgia",
  "University of Hartford",
  "University of Hawaii at Hilo",
  "University of Hawaii at Manoa",
  "University of Hawaii-West Oahu",
  "University of Houston",
  "University of Idaho",
  "University of Illinois at Chicago",
  "University of Illinois at Urbana-Champaign",
  "University of Iowa",
  "University of Kansas",
  "University of Kentucky",
  "University of Las Vegas",
  "University of Louisiana at Lafayette",
  "University of Louisville",
  "University of Maine",
  "University of Mary",
  "University of Maryland-Baltimore County",
  "University of Maryland-College Park",
  "University of Maryland-University College",
  "University of Massachusetts Amherst",
  "University of Memphis",
  "University of Miami",
  "University of Michigan",
  "University of Minnesota-Duluth",
  "University of Minnesota-Twin Cities",
  "University of Mississippi",
  "University of Missouri-Columbia",
  "University of Missouri-Kansas City",
  "University of Montana",
  "University of Montana-Western",
  "University of Nebraska at Kearney",
  "University of Nebraska at Omaha",
  "University of Nebraska-Lincoln",
  "University of Nevada-Las Vegas",
  "University of Nevada-Reno",
  "University of New England",
  "University of New Hampshire",
  "University of New Haven",
  "University of New Mexico",
  "University of North Carolina at Chapel Hill",
  "University of North Carolina at Charlotte",
  "University of North Carolina - Wilmington",
  "University of North Dakota",
  "University of Northern Colorado",
  "University of Northern Iowa",
  "University of North Florida",
  "University of North Texas",
  "University of Notre Dame",
  "University of Oklahoma Norman Campus",
  "University of Oregon",
  "University of Pennsylvania",
  "University of Phoenix-Online Campus",
  "University of Phoenix-Phoenix-Hohokam Campus",
  "University of Pittsburgh-Pittsburgh Campus",
  "University of Portland",
  "University of Puget Sound",
  "University of Rhode Island",
  "University of San Diego",
  "University of San Francisco",
  "University of Santa Clara",
  "University of South Alabama",
  "University of South California",
  "University of South Carolina-Columbia",
  "University of South Dakota",
  "University of Southern Maine",
  "University of Southern Mississippi",
  "University of South Florida-Tampa",
  "University of South Florida-St. Petersburg",
  "University of Tennessee",
  "University of Tennessee at Chattanooga",
  "University of Texas at Arlington",
  "University of Texas at Austin",
  "University of Texas at San Antonio",
  "University of the District of Columbia",
  "University of Toledo",
  "University of Tulsa",
  "University of Utah",
  "University of Vermont",
  "University of Virginia",
  "University of Washington",
  "University of Wisconsin, Oshkosh",
  "University of Wisconsin Colleges",
  "University of Wisconsin-Eau Claire",
  "University of Wisconsin-La Crosse",
  "University of Wisconsin-Madison",
  "University of Wisconsin-Milwaukee",
  "University of Wisconsin-Whitewater",
  "University of Wyoming",
  "University San Diego",
  "Utah State University",
  "Utah Valley University",
  "Valdosta State University",
  "Vanderbilt University",
  "Villanova University",
  "Virginia Commonwealth University",
  "Virginia Polytechnic Institute and State University",
  "Walden University",
  "Washington State University",
  "Washington University in St Louis",
  "Wayne State College",
  "Wayne State University",
  "Weber State University",
  "Wesley College",
  "Western Kentucky University",
  "Western Michigan University",
  "Western Oregon University",
  "Western Washington University",
  "West Virginia State University",
  "West Virginia University",
  "Whitworth University",
  "Wichita State University",
  "Williams College",
  "Wilmington University",
  "Winona State University",
  "Winthrop University",
  "Wright State University",
  "Wyotech-Laramie",
  "Xavier University of Louisiana",
  "Yale University",
  "Youngstown State University",
  "Other"
];
export const UniversityUK = [
  "Aberystwyth University",
  "American Intercontinental University",
  "Anglia Ruskin University (Cambridge)",
  "Anglia Ruskin University (Chelmsford)",
  "Aston University",
  "Bangor University",
  "Bath Spa University",
  "Belfast Royal Hospitals",
  "Birmingham City University (UCE)",
  "Bishop Grosseteste University College",
  "Boston University",
  "Bournemouth University",
  "British College of Osteopathic Medicine",
  "British School of Osteopathy",
  "Brunel University",
  "Buckinghamshire New University",
  "Camberwell College of Arts (University of the Arts London)",
  "Camborne School of Mines",
  "Canterbury Christ Church University",
  "Canterbury College",
  "Cardiff Metropolitan University",
  "Cardiff University",
  "Central Saint Martins College of Art and Design (University of the Arts London)",
  "Central School of Speech and Drama",
  "Chelsea College of Art and Design (University of the Arts London)",
  "City University",
  "Courtauld Institute of Art",
  "Coventry University",
  "Cranfield University",
  "Crichton University Campus",
  "De Montfort University",
  "Durham University",
  "Durham University (Queen's Campus, Stockton)",
  "Edge Hill University",
  "Edinburgh College of Art",
  "Edinburgh Napier University",
  "Falmouth University",
  "Glasgow Caledonian University",
  "Glasgow School of Art",
  "Glyndwr University (NEWI)",
  "Guildford College",
  "Harper Adams University College",
  "Henley Business School",
  "Heriot-Watt University",
  "Homerton College, Cambridge",
  "Hult International Business School",
  "Imperial College London",
  "Imperial College London at Wye",
  "Institute for System Level Integration",
  "Institute of Child Health",
  "Institute of Historical Research",
  "Institute of Neurology",
  "Irish School of Ecumenics, Trinity College Dublin",
  "Keele University",
  "Kingston University",
  "Lancaster University",
  "Leeds College of Music",
  "Leeds Metropolitan University",
  "Leeds Trinity University",
  "Liverpool Hope University",
  "Liverpool John Moores University",
  "London College of Fashion (University of the Arts London)",
  "London College of Management Studies",
  "London Metropolitan University",
  "London South Bank University",
  "Loughborough University",
  "Manchester Business School",
  "Manchester Metropolitan University",
  "Met Film School",
  "Middlesex University",
  "Moray House School of Education",
  "Newcastle University",
  "Newman University College",
  "Northern School of Contemporary Dance",
  "Northumbria University",
  "Norwich University of the Arts",
  "Nottingham Trent University",
  "Oxford Brookes University",
  "Queen's University Belfast",
  "Queen Margaret University",
  "Ravensbourne College of Design and Communication",
  "Richmond, The American International University in London",
  "Robert Gordon University",
  "Roehampton University",
  "Rose Bruford College",
  "Royal Academy of Music",
  "Royal Agricultural College",
  "Royal College of Nursing",
  "Royal Northern College of Music",
  "Royal Scottish Academy of Music and Drama",
  "Royal Welsh College of Music and Drama",
  "SAC (The Scottish Agricultural College)",
  "Schiller International University",
  "School of Pharmacy, University of London",
  "Sheffield Hallam University",
  "Southampton Solent University",
  "St.Mary's University College (Belfast)",
  "Staffordshire University",
  "St Mary's University College (Twickenham)",
  "Stranmillis University College",
  "Swansea University",
  "Teesside University",
  "The City Law School",
  "The College of Estate Management",
  "The Hull York Medical School",
  "The London College of Communication (University of the Arts London)",
  "The Open University",
  "The Royal College of Art",
  "The Royal College of Music",
  "The Royal Veterinary College",
  "The University of South Wales",
  "The University of South Wales - Newport Campus",
  "Trinity College of Music",
  "Trinity Laban",
  "University Campus Suffolk",
  "University College Birmingham",
  "University College for the Creative Arts at Canterbury, Epsom, Farnham, Maidstone and Rochester",
  "University College London (UCL)",
  "University College London (UCL) Eastman Dental Institute",
  "University College London (UCL) School of Slavonic and East European Studies",
  "University of Aberdeen",
  "University of Abertay Dundee",
  "University of Bath",
  "University of Bedfordshire",
  "University of Birmingham",
  "University of Bolton",
  "University of Bradford",
  "University of Brighton",
  "University of Bristol",
  "University of Buckingham",
  "University of Cambridge",
  "University of Central Lancashire",
  "University of Central Lancashire (Preston Campus)",
  "University of Chester",
  "University of Chichester",
  "University of Cumbria",
  "University of Delaware",
  "University of Derby",
  "University of Dundee",
  "University of East Anglia",
  "University of East London",
  "University of Edinburgh",
  "University of Essex",
  "University of Exeter",
  "University of Glasgow",
  "University of Gloucestershire",
  "University of Greenwich",
  "University of Hertfordshire",
  "University of Huddersfield",
  "University of Hull",
  "University of Hull (Scarborough Campus)",
  "University of Kent",
  "University of Law",
  "University of Leeds",
  "University of Leicester",
  "University of Lincoln",
  "University of Liverpool",
  "University of London",
  "University of London, London Business School",
  "University of London Birkbeck College",
  "University of London Goldsmiths College",
  "University of London Heythrop College",
  "University of London Institute of Cancer Research",
  "University of London Institute of Education",
  "University of London Institute of Psychiatry",
  "University of London King's College London",
  "University of London Queen Mary",
  "University of London Royal Holloway",
  "University of London School of Advanced Studies",
  "University of London School of Economics and Political Science",
  "University of London School of Hygiene and Tropical Medicine",
  "University of London School of Oriental and African Studies",
  "University of London St. George's Hospital Medical School",
  "University of Manchester",
  "University of Northampton",
  "University of Notre Dame",
  "University of Nottingham",
  "University of Oxford",
  "University of Plymouth",
  "University of Portsmouth",
  "University of Reading",
  "University of Salford",
  "University of Sheffield",
  "University of Southampton",
  "University of St Andrews",
  "University of Stirling",
  "University of St Mark &amp; St John",
  "University of Strathclyde",
  "University of Sunderland",
  "University of Surrey",
  "University of Sussex",
  "University of the Arts London",
  "University of the Highlands and Islands",
  "University of the West of England (UWE Bristol)",
  "University of the West of Scotland",
  "University of Ulster",
  "University of Wales",
  "University of Wales Trinity Saint David - Carmarthen Campus",
  "University of Wales Trinity Saint David - Swansea Campus",
  "University of Warwick",
  "University of West London",
  "University of Westminster",
  "University of Winchester",
  "University of Wolverhampton",
  "University of Worcester",
  "University of York",
  "Warrington Collegiate",
  "Wiltshire College",
  "Wimbledon College of Art (University of the Arts London)",
  "Writtle College",
  "Other"
];
export const UniversityAustralia = [
  "Australian Catholic University",
  "Australian National University",
  "Bond University",
  "Carnegie Mellon University",
  "Charles Darwin University",
  "Charles Sturt University",
  "CQ University",
  "Curtin University",
  "Deakin University",
  "Edith Cowen University",
  "Federation University of Australia",
  "Flinders University",
  "Griffith University",
  "James Cook University",
  "La Trobe University",
  "Macquarie University",
  "Monash University",
  "Murdoch University",
  "Queensland University of Technology",
  "RMIT University",
  "Southern Cross University",
  "Swinburne University of Technology",
  "Torrens University Australia",
  "University College London",
  "University of Adelaide",
  "University of Canberra",
  "University of Divinity",
  "University of Melbourne",
  "University of Newcastle",
  "University of New England",
  "University of New South Wales",
  "University of Notre Dame Australia",
  "University of Queensland",
  "University of South Australia",
  "University of Southern Queensland",
  "University of Sydney",
  "University of Tasmania",
  "University of Technology, Sydney",
  "University of the Sunshine Coast",
  "University of Western Sydney",
  "University of Wollongong",
  "Victoria University",
  "Other"
];

export const UniversityCAN = [
  "University of British Columbia",
  "University of Sudbury",
  "University of Toronto",
  "University of Victoria",
  "Other"
]